import {makeAutoObservable} from "mobx"
import {nextId} from "../utils"
import {ReactNode} from "react"

export interface GrowMessage {
    closable?: boolean
    message: ReactNode
    autoclose?: boolean | number
    cls?: string
}

interface InternalMessage extends GrowMessage{
    id: string
}

class GrowlStore {
    get messages(): InternalMessage[] {
        return this._messages
    }

    private set messages(value: InternalMessage[]) {
        this._messages = value
    }

    private _messages: InternalMessage[] = []

    constructor() {
        makeAutoObservable(this)
    }

    public add(message: GrowMessage) {
        const id = `${nextId()}`
        const m: InternalMessage = {
            ...message,
            id
        }
        this.messages.push(m)

        if (m.autoclose) {
            const id = m.id
            const duration = m.autoclose === true || !m.autoclose ? 3000 : m.autoclose
            window.setTimeout(() => {
                this.remove(id)
            }, duration)
        }
    }

    remove(id: string) {
        this.messages = this.messages.filter(e => e.id !== id)
    }

    clear() {
        this.messages = []
    }
}

const growlStore = new GrowlStore()

export {
    growlStore
}
